export function geocodeStringAddress(stringAddress: string) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/scheduling/geocode-address`,
    body: {
      stringAddress,
    },
  }
}
